import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const DexscreenerReaction = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Dexscreener Reaction - Buy Dexmoji Rockets & Emoji | Dexreaction</title>
        <meta name="description" content="Buy Dexscreener reaction - the fastest & cheapest Dexmoji bot! Buy rocket 🚀, fire 🔥, star ⭐ reactions from $0.05. Natural delivery patterns, instant start. Boost token trending score!" />
        <meta name="keywords" content="dexscreener reaction, buy dexscreener reaction, buy dexscreener rockets, buy dexscreener fire, buy dexscreener poop, dexreactions, dexscreener reactions bot, buy dexmoji, dexscreener emoji, dexscreener rockets, telegram dexscreener bot, boost dexscreener trending, crypto token reactions, dexscreener visibility, cheap dexscreener reactions" />
        <link rel="canonical" href="https://dexreaction.com/dexscreener-reaction" />
        <meta property="og:title" content="Buy Dexscreener Reaction - Cheapest Dexmoji Service | Dexreaction" />
        <meta property="og:description" content="Buy Dexscreener reaction - rockets, fire, star emojis from $0.05. Fastest delivery, natural patterns!" />
        <meta property="og:image" content="https://dexreaction.com/og-image.png" />
        <meta property="og:image" content="https://dexreaction.com/logo-light.png" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-indigo-900/20 to-slate-900">
        {/* Header */}
        <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-indigo-500/20 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                <img src="/logo-light.png" alt="Dexreaction" className="h-8" />
              </div>
              <button
                onClick={() => navigate('/')}
                className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors"
              >
                Get Started
              </button>
            </div>
          </div>
        </nav>

        {/* Hero - Service Focus */}
        <section className="pt-32 pb-20 px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block bg-indigo-500/20 text-indigo-300 px-6 py-2 rounded-full text-sm font-semibold mb-6">
                #1 DexScreener Reaction Service
              </span>
              <h1 className="text-5xl md:text-7xl font-bold mb-6">
                DexScreener <br />
                <span className="bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
                  Reaction Service
                </span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
                Professional service to boost your token's DexScreener reactions. Increase visibility, build credibility, and attract more investors.
              </p>
            </div>

            {/* Service Stats */}
            <div className="grid md:grid-cols-4 gap-6 mb-12">
              {[
                { number: '500+', label: 'Tokens Boosted' },
                { number: '1M+', label: 'Reactions Delivered' },
                { number: '99.9%', label: 'Success Rate' },
                { number: '24/7', label: 'Service Uptime' }
              ].map((stat, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-indigo-500/20 rounded-xl p-6 text-center">
                  <div className="text-3xl md:text-4xl font-bold text-indigo-400 mb-2">{stat.number}</div>
                  <div className="text-gray-400">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="text-center">
              <button
                onClick={() => navigate('/')}
                className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white px-10 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 inline-flex items-center gap-2"
              >
                Start Your Campaign
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
            </div>
          </div>
        </section>

        {/* Service Features */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              Why Choose Our Reaction Service?
            </h2>
            <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">
              We provide the most reliable and professional DexScreener reaction service in the crypto space
            </p>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  icon: '🎯',
                  title: 'Targeted Delivery',
                  desc: 'Choose specific reaction types that match your token sentiment and marketing goals'
                },
                {
                  icon: '📈',
                  title: 'Organic Growth',
                  desc: 'Natural delivery rate of 500 reactions per 10 minutes ensures authentic-looking engagement'
                },
                {
                  icon: '🛡️',
                  title: 'Safe & Compliant',
                  desc: 'All reactions delivered through legitimate accounts following DexScreener guidelines'
                },
                {
                  icon: '⚡',
                  title: 'Instant Processing',
                  desc: 'Orders start immediately after payment - no delays or waiting periods'
                },
                {
                  icon: '💰',
                  title: 'Best Value',
                  desc: 'Competitive pricing with 20% bonus reactions on every order'
                },
                {
                  icon: '🔧',
                  title: 'Full Control',
                  desc: 'Customize quantity, reaction type, and delivery schedule to your needs'
                }
              ].map((feature, idx) => (
                <div key={idx} className="bg-gradient-to-br from-slate-800/50 to-indigo-900/20 border border-indigo-500/20 rounded-xl p-6 hover:border-indigo-500/50 transition-all">
                  <div className="text-4xl mb-4">{feature.icon}</div>
                  <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
                  <p className="text-gray-400">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How Our Service Works */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              How Our Service Works
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div className="bg-slate-800/50 border-l-4 border-indigo-500 rounded-r-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-10 h-10 bg-indigo-600 rounded-full flex items-center justify-center font-bold">
                      1
                    </div>
                    <div>
                      <h3 className="text-lg font-bold mb-2">Select Your Package</h3>
                      <p className="text-gray-400">Choose from preset packages or enter custom quantity. All packages include 20% bonus.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-slate-800/50 border-l-4 border-indigo-500 rounded-r-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-10 h-10 bg-indigo-600 rounded-full flex items-center justify-center font-bold">
                      2
                    </div>
                    <div>
                      <h3 className="text-lg font-bold mb-2">Choose Reaction Type</h3>
                      <p className="text-gray-400">Select from Rocket, Fire, Favorite, Poop, or Red Flag reactions based on your strategy.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-slate-800/50 border-l-4 border-indigo-500 rounded-r-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-10 h-10 bg-indigo-600 rounded-full flex items-center justify-center font-bold">
                      3
                    </div>
                    <div>
                      <h3 className="text-lg font-bold mb-2">Provide Token Details</h3>
                      <p className="text-gray-400">Enter your DexScreener token link where reactions will be delivered.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="space-y-6">
                <div className="bg-slate-800/50 border-l-4 border-purple-500 rounded-r-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center font-bold">
                      4
                    </div>
                    <div>
                      <h3 className="text-lg font-bold mb-2">Complete Payment</h3>
                      <p className="text-gray-400">Pay securely with Solana through wallet connection or manual transfer.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-slate-800/50 border-l-4 border-purple-500 rounded-r-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center font-bold">
                      5
                    </div>
                    <div>
                      <h3 className="text-lg font-bold mb-2">Instant Delivery Starts</h3>
                      <p className="text-gray-400">Reactions begin delivering immediately at 500 per 10 minutes for natural growth.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-slate-800/50 border-l-4 border-purple-500 rounded-r-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center font-bold">
                      6
                    </div>
                    <div>
                      <h3 className="text-lg font-bold mb-2">Track Your Results</h3>
                      <p className="text-gray-400">Monitor your DexScreener listing and watch engagement grow in real-time.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Reaction Types Service Explanation */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Reaction Service Options
            </h2>
            <div className="grid md:grid-cols-5 gap-6">
              {[
                {
                  emoji: '🚀',
                  name: 'Rocket Service',
                  desc: 'Most popular for bullish tokens',
                  link: '/buy-rocket-dexscreener'
                },
                {
                  emoji: '🔥',
                  name: 'Fire Service',
                  desc: 'Perfect for trending tokens',
                  link: '/'
                },
                {
                  emoji: '⭐',
                  name: 'Favorite Service',
                  desc: 'Build community love',
                  link: '/'
                },
                {
                  emoji: '💩',
                  name: 'Poop Service',
                  desc: 'Meme token favorite',
                  link: '/'
                },
                {
                  emoji: '🚩',
                  name: 'Red Flag Service',
                  desc: 'Warning signals',
                  link: '/'
                }
              ].map((service, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-indigo-500/20 rounded-xl p-6 text-center hover:border-indigo-500/50 transition-all group">
                  <div className="text-5xl mb-3 transform group-hover:scale-110 transition-transform">{service.emoji}</div>
                  <h3 className="font-bold mb-2">{service.name}</h3>
                  <p className="text-sm text-gray-400 mb-4">{service.desc}</p>
                  <button
                    onClick={() => navigate(service.link)}
                    className="text-indigo-400 hover:text-indigo-300 text-sm font-semibold"
                  >
                    Learn More →
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Service Packages */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              Service Packages
            </h2>
            <p className="text-center text-gray-400 mb-12">
              All packages include 20% bonus reactions + fast delivery
            </p>
            <div className="grid md:grid-cols-4 gap-6">
              {[
                { name: 'Starter', qty: 500, price: 25, total: 600, popular: false },
                { name: 'Growth', qty: 1000, price: 50, total: 1200, popular: true },
                { name: 'Professional', qty: 1500, price: 75, total: 1800, popular: false },
                { name: 'Enterprise', qty: 2000, price: 100, total: 2400, popular: false }
              ].map((pkg) => (
                <div key={pkg.name} className={`relative bg-slate-800/50 border-2 ${pkg.popular ? 'border-indigo-500' : 'border-indigo-500/20'} rounded-xl p-6 hover:border-indigo-500/50 transition-all`}>
                  {pkg.popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 py-1 rounded-full text-sm font-bold">
                        Most Popular
                      </span>
                    </div>
                  )}
                  <div className="text-center">
                    <h3 className="text-xl font-bold mb-2">{pkg.name}</h3>
                    <div className="text-4xl font-bold text-indigo-400 mb-2">${pkg.price}</div>
                    <div className="text-gray-400 mb-4">{pkg.qty} reactions</div>
                    <div className="bg-indigo-500/20 rounded-lg p-3 mb-4">
                      <div className="text-sm text-gray-400">You Get:</div>
                      <div className="text-2xl font-bold text-green-400">{pkg.total}</div>
                      <div className="text-xs text-gray-400">with 20% bonus</div>
                    </div>
                    <button
                      onClick={() => navigate('/')}
                      className={`w-full ${pkg.popular ? 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700' : 'bg-indigo-600 hover:bg-indigo-700'} text-white py-3 rounded-lg font-semibold transition-all`}
                    >
                      Select Package
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Service FAQ
            </h2>
            <div className="space-y-4">
              {[
                {
                  q: 'Is this service safe for my token?',
                  a: 'Yes, our service is completely safe. We deliver reactions through authentic accounts following DexScreener guidelines. Your token will not be penalized or flagged.'
                },
                {
                  q: 'How fast will I receive reactions?',
                  a: 'Delivery starts immediately after payment verification. We deliver 500 reactions every 10 minutes to ensure natural-looking growth.'
                },
                {
                  q: 'Can I choose multiple reaction types?',
                  a: 'Each order is for a single reaction type. For multiple reaction types, please place separate orders.'
                },
                {
                  q: 'What makes your service different?',
                  a: 'We provide the fastest delivery, best pricing, 20% bonus reactions, and 24/7 automated service with instant order processing.'
                },
                {
                  q: 'Do you offer refunds?',
                  a: 'Due to the instant digital nature of our service, refunds are not available. However, we guarantee delivery of all purchased reactions.'
                }
              ].map((faq, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-indigo-500/20 rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-3 text-indigo-400">{faq.q}</h3>
                  <p className="text-gray-400">{faq.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Ready to Use Our Service?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Join hundreds of successful token projects using Dexreaction reaction service
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
            >
              Start Your Service Now
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 border-t border-indigo-500/20 py-8 px-4">
          <div className="max-w-6xl mx-auto text-center text-gray-400">
            <p>&copy; 2025 Dexreaction. All rights reserved.</p>
            <div className="mt-4 space-x-4">
              <button onClick={() => navigate('/terms')} className="hover:text-indigo-400 transition-colors">Terms</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-indigo-400 transition-colors">Privacy</button>
              <button onClick={() => navigate('/')} className="hover:text-indigo-400 transition-colors">Contact</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default DexscreenerReaction;
